import pageMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-page.mixin.js";

export default {
  mixins: [pageMenuEventBubbler],
  props: {
    inertProp: Boolean,
  },
};
